import { useLocation, useNavigate } from "react-router-dom";

/**
 * 返回目标:字符串 = 深链落地(无栈内历史)时的兜底路径;-1 = 只退历史,兜底回首页。
 */
export type BackTo = string | -1;

/**
 * 二级页返回的三层兜底(抄自 PC `/advisor/chat` AdvisorChatFullPage.useReturnToSource,
 * 0829 收口成全站唯一实现):
 * ① 跳转时带来的来源路由(`location.state.from`)→ 优先回它;
 * ② 无来源但站内有栈(react-router 自维护的 `history.state.idx > 0`)→ `navigate(-1)`;
 * ③ 深链直达 / 刷新落地(idx 恒 0)→ 退到 `backTo` 给的兜底路径(-1 时退首页),绝不留在原地。
 */
export function useBackNav(backTo: BackTo): () => void {
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from;
  return () => {
    if (from) {
      navigate(from);
      return;
    }
    const idx = (window.history.state as { idx?: number } | null)?.idx ?? 0;
    if (idx > 0) {
      navigate(-1);
      return;
    }
    navigate(backTo === -1 ? "/" : backTo);
  };
}
